import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { DarkModeProvider } from './components/assets/DarkModeContext';
import AuthGuard from './components/SSO/AuthGuard';
import TranslationContextProvider from "./context/translations/translations-context";
import CreatePassword from "./Pages/Inscription/CreatePassword";
import CreatePasswordClient from "./Pages/Inscription/CreatePasswordClient";
import Inscription from './Pages/Inscription/Inscription';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'typeface-roboto';

const container = document.getElementById( "root" );
const root = createRoot( container );

root.render(
    <Router>
        <DarkModeProvider>
            <ToastContainer position="top-center"/>
            <Route path="/inscription" component={ Inscription }/>
            <Route path="/create-password/:token" component={ CreatePassword }/>
            <Route path="/create-password-client/:token" component={ CreatePasswordClient }/>
            <AuthGuard>
                <TranslationContextProvider>
                    <App/>
                </TranslationContextProvider>
            </AuthGuard>
        </DarkModeProvider>
    </Router>
);

serviceWorkerRegistration.register();
reportWebVitals();
